export const place_details_events = {
  itinerary_act_list_selection_close_click: {
    category: "Restaurant list dialog interaction",
    action: "User closes the restaurant list dialog",
    label: "itinerary-act-list-selection-close-click",
  },
  itinerary_act_list_option_click: {
    category: "Restaurant list dialog interaction",
    action: "User clicks on a restaurant card in the list",
    label: "itinerary-act-list-option-click",
  },
  itinerary_act_tab_overview_click: {
    category: "Place details dialog interaction",
    action: "User clicks on the overview tab",
    label: "itinerary-act-tab-overview-click",
  },
  itinerary_act_tab_about_click: {
    category: "Place details dialog interaction",
    action: "User clicks on the about tab",
    label: "itinerary-act-tab-about-click",
  },
  itinerary_act_tab_reviews_click: {
    category: "Place details dialog interaction",
    action: "User clicks on the reviews tab",
    label: "itinerary-act-tab-reviews-click",
  },
  itinerary_act_image_select_click: {
    category: "Place details dialog interaction",
    action: "User clicks to change/select an image in the detail dialog",
    label: "itinerary-act-image-select-click",
  },
  itinerary_act_details_close_click: {
    category: "Place details dialog interaction",
    action: "User closes the place details dialog",
    label: "itinerary-act-details-close-click",
  },
  itinerary_act_details_activity_view_click: {
    category: "Place details dialog interaction",
    action: "User clicks on an activity to view details",
    label: "itinerary-details-activity-view-click",
  },
};
